module.exports = __webpack_public_path__ + "static/media/avatarWrapper.f8e4f794.png";